import React, { useState, useEffect } from 'react';
import useBodyClass from 'helpers/hooks/useBodyClass';
import { Link } from 'react-router-dom';
import { Commission, COMMISSION_TYPES, Props } from './CommissionListingPage.types';
import { commissionTerms } from 'routes/routePaths';
import { Box, Tabs } from 'modules/af_cm_ui_kit';
import { fetchAllCommissions } from 'modules/commission_terms/api';
import CommissionListingItem from './partials/CommissionListingItem/CommissionListingItem';

import styles from './CommissionListingPage.module.scss';

const CommissionListingPage: React.FC<Props> = () => {
  useBodyClass(...styles['new-cm'].split(' '));

  const [commissions, setCommissions] = useState<Commission[]>([]);

  useEffect(() => {
    const fetchCommissions = async () => {
      const { data } = await fetchAllCommissions();
      setCommissions(data);
    };

    fetchCommissions();
  }, []);

  const commissionListingTab = (commissionItems: Commission[]) => (
    <div>
      {commissionItems.map((commissionItem) => (
        <CommissionListingItem key={commissionItem.id} commissionItem={commissionItem} />
      ))}
    </div>
  );

  const ongoingCommissions = commissions.filter((item) => item.type === COMMISSION_TYPES.ONGOING);
  const standardCommissions = commissions.filter((item) => item.type === COMMISSION_TYPES.STANDARD);
  const enhancedCommissions = commissions.filter((item) => item.type === COMMISSION_TYPES.ENHANCED);

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.heading}>
          <p className={styles.header}>Commission Terms</p>
          <Link className={styles.createButton} to={commissionTerms.create}>
            Create
          </Link>
        </div>
      </div>
      <Box title="Available commissions">
        <Tabs
          labels={[
            { value: 'All', hasError: false },
            { value: 'Standard', hasError: false },
            { value: 'Enhanced up-front', hasError: false },
            { value: 'Ongoing', hasError: false },
          ]}>
          <>{commissionListingTab(commissions)}</>
          <>{commissionListingTab(standardCommissions)}</>
          <>{commissionListingTab(enhancedCommissions)}</>
          <>{commissionListingTab(ongoingCommissions)}</>
        </Tabs>
      </Box>
    </>
  );
};

export default CommissionListingPage;
